const RCU_PATH = '/rcu/api';
const HUB_API_PATH = '/hub/api';

export { RCU_PATH, HUB_API_PATH };
